import React, { useEffect, useState } from 'react'
import { get, post, put, deleteApi } from '../../utils/apiManager'
import CIcon from '@coreui/icons-react'
import { cilPlus } from '@coreui/icons'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CHeader,
  CTable,
  CRow,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CFormLabel,
} from '@coreui/react'
import { toast } from 'react-toastify'
import { FaEdit, FaTrash } from 'react-icons/fa'

function Remarks() {
  const [remarksList, setRemarksList] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [currentRemark, setCurrentRemark] = useState({ _id: null, remark: '' })
  const [loading, setLoading] = useState(false)

  const getData = () => {
    get('/admin/note-remark/get').then((res) => {
      if (res?.status) {
        setRemarksList(res?.data || [])
      } else {
        setRemarksList([])
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const handleOpenAdd = () => {
    setCurrentRemark({ _id: null, remark: '' })
    setModalVisible(true)
  }

  const handleOpenEdit = (item) => {
    setCurrentRemark({ _id: item._id, remark: item.remark })
    setModalVisible(true)
  }

  const handleSave = () => {
    if (!currentRemark.remark || !currentRemark.remark.trim()) {
      toast.error('Please enter note/remark')
      return
    }

    setLoading(true)
    if (currentRemark._id) {
      put(`/admin/note-remark/update-note?id=${currentRemark._id}`, { remark: currentRemark.remark.trim() }).then((res) => {
        setLoading(false)
        if (res?.status) {
          toast.success(res?.message || 'Updated successfully')
          setModalVisible(false)
          getData()
        } else {
          toast.error(res?.message || 'Update failed')
        }
      })
    } else {
      post('/admin/note-remark/add-note', { remark: currentRemark.remark.trim() }).then((res) => {
        setLoading(false)
        if (res?.status) {
          toast.success(res?.message || 'Created successfully')
          setModalVisible(false)
          getData()
        } else {
          toast.error(res?.message || 'Creation failed')
        }
      })
    }
  }

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this note/remark?')) {
      deleteApi(`/admin/note-remark/delete-note?id=${id}`).then((res) => {
        if (res?.status) {
          toast.success(res?.message || 'Deleted successfully')
          getData()
        } else {
          toast.error(res?.message || 'Delete failed')
        }
      })
    }
  }

  return (
    <>
      <CContainer fluid>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard className="p-4">
                <CHeader>
                  <CRow className="w-100 align-items-center">
                    <CCol md="8">
                      <h2 className="mb-0">Package Notes & Remarks</h2>
                      <small className="text-muted">These notes appear under the "NOTES / REMARK" section on the Package Details screen in the customer app.</small>
                    </CCol>
                    <CCol md="4" className="text-end">
                      <CButton
                        style={{ backgroundColor: '#d3dc40', border: '#d3dc40', color: '#000' }}
                        onClick={handleOpenAdd}
                      >
                        <CIcon icon={cilPlus} /> Add Note / Remark
                      </CButton>
                    </CCol>
                  </CRow>
                </CHeader>
                <CCardBody>
                  <CTable bordered hover responsive>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell style={{ width: '80px' }}>S. No</CTableHeaderCell>
                        <CTableHeaderCell>Note / Remark (App text)</CTableHeaderCell>
                        <CTableHeaderCell style={{ width: '140px', textAlign: 'center' }}>Action</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {remarksList && remarksList.length > 0 ? (
                        remarksList.map((item, index) => (
                          <CTableRow key={item._id || index}>
                            <CTableDataCell>{index + 1}</CTableDataCell>
                            <CTableDataCell>{item.remark}</CTableDataCell>
                            <CTableDataCell className="text-center">
                              <CButton
                                color="warning"
                                size="sm"
                                className="me-2 text-white"
                                onClick={() => handleOpenEdit(item)}
                              >
                                <FaEdit />
                              </CButton>
                              <CButton
                                color="danger"
                                size="sm"
                                className="text-white"
                                onClick={() => handleDelete(item._id)}
                              >
                                <FaTrash />
                              </CButton>
                            </CTableDataCell>
                          </CTableRow>
                        ))
                      ) : (
                        <CTableRow>
                          <CTableDataCell colSpan="3" className="text-center text-danger">
                            No Notes / Remarks found
                          </CTableDataCell>
                        </CTableRow>
                      )}
                    </CTableBody>
                  </CTable>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>

      {/* Add / Edit Modal */}
      <CModal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader>
          <CModalTitle>{currentRemark._id ? 'Edit Note / Remark' : 'Add Note / Remark'}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <CFormLabel>Note / Remark Text *</CFormLabel>
            <CFormInput
              type="text"
              placeholder="Enter note or remark"
              value={currentRemark.remark}
              onChange={(e) => setCurrentRemark({ ...currentRemark, remark: e.target.value })}
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setModalVisible(false)}>
            Cancel
          </CButton>
          <CButton
            style={{ backgroundColor: '#d3dc40', border: '#d3dc40', color: '#000' }}
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default Remarks
